import React from "react";
import { useSearchParams } from "react-router-dom";

import CustomTabs from "components/Shared/CustomTabs";
import CustomTabPanel from "components/Shared/CustomTabPanel";
import RowsSkeleton from "components/Shared/Skeleton/RowsSkeleton";

import { useEBillProviderDetailContext } from "contexts/EBillProviderDetailContext";
import EBillProviderEndpointsTab from "./EBillProviderEndpointsTab";
import EBillProviderCredentialsTab from "./EBillProviderCredentialsTab";
import { useListCredentialsQuery } from "store/services/eBillProviderApi";
import EBillProviderRelayTab from "./EBillProviderRelayTab";

const EBillProviderDetailTab = () => {
  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get("tab") || "endpoints";

  const { eBillProviderDetail } = useEBillProviderDetailContext();

  const { data: credentialsData } = useListCredentialsQuery(
    eBillProviderDetail?._id,
    { skip: !eBillProviderDetail?._id }
  );

  const tabs = [
    {
      label: "Endpoints",
      value: "endpoints",
      badgeCount: eBillProviderDetail?.endpoints?.length || 0,
    },
    {
      label: "Credentials",
      value: "credentials",
      badgeCount: credentialsData?.data?.length || 0,
    },
    {
      label: "VPC-Relay",
      value: "vpc-relay",
      badgeCount: eBillProviderDetail?.relayConfig ? 1 : 0,
    }
  ];

  return (
    <>
      <CustomTabs tabs={tabs} activeTab={activeTab} />

      {eBillProviderDetail ? (
        <>
          <CustomTabPanel activeTab={activeTab} value="endpoints">
            <EBillProviderEndpointsTab />
          </CustomTabPanel>

          <CustomTabPanel activeTab={activeTab} value="credentials">
            <EBillProviderCredentialsTab />
          </CustomTabPanel>

          <CustomTabPanel activeTab={activeTab} value="vpc-relay">
            <EBillProviderRelayTab />
          </CustomTabPanel>
        </>
      ) : (
        <RowsSkeleton />
      )}
    </>
  );
};

export default EBillProviderDetailTab;